import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Randomize playlist order", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "warn" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Note"),
    /*#__PURE__*/_createTextVNode(": This tool will create a new playlist in your library, rather than modifying the existing one.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "This is partially due to API limitations, and it also helps prevent bugs from ruining playlists.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent)))
  ], 64))
}